import Lottie, { LottieProps } from 'react-lottie'
import clsx from 'clsx'
import i18n from 'src/i18n'
import * as animationData from './assets/animation.json'
import { FirstCommentBadgeProps } from './firstCommentBadge.types'
import { Wrapper } from './firstCommentBadge.styles'

const FirstCommentBadge = ({ className }: FirstCommentBadgeProps) => {
  const defaultOptions: LottieProps['options'] = {
    loop: false,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <Wrapper className={clsx('_d-flex _align-items-center', className)}>
      <Lottie options={defaultOptions} width={16} height={18.64} />
      <span className="_ml-2 _text-yellow _text-1 _font-weight-bold">
        {i18n.t('feed.comments.first_comment')}
      </span>
    </Wrapper>
  )
}

export default FirstCommentBadge
